// Based on https://gist.github.com/cowboy/661855#gistcomment-82450
(function tinyPubSub() {
  const dataCache = {};
  const firedCache = {};
  const jQueryObject = $({});

  $.subscribe = function subscribe(topic, callback, options) {
    const callbackHandler = (event, data) => {
      callback(data);
    };

    jQueryObject.on.bind(jQueryObject)(topic, callbackHandler);

    if (options && options.immediate && typeof firedCache[topic] !== 'undefined') {
      callback(dataCache[topic]);
    }

    return {
      unsubscribe() {
        jQueryObject.off.bind(jQueryObject)(topic, callbackHandler);
      },
    };
  };

  $.publish = function publish(topic, data) {
    jQueryObject.trigger.bind(jQueryObject)(topic, data);
    dataCache[topic] = data;
    firedCache[topic] = true;
  };
}());
